// Pounds typed by a person → whole pence, or null if it isn't a positive amount.
export function poundsToPence(input) {
  const text = String(input ?? '').trim();
  if (!text) return null;
  const pounds = Number(text);
  if (!Number.isFinite(pounds)) return null;
  // toFixed first: 12.345 * 100 is 1234.4999… in floating point
  const pence = Math.round(Number((pounds * 100).toFixed(6)));
  return pence >= 1 ? pence : null;
}

export function formatPence(pence) {
  return (pence / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' });
}
